import { useAuthStore } from "../stores/authStore";

export function getSessionUser() {
  return useAuthStore.getState().user;
}

export function setSessionUser(user) {
  useAuthStore.getState().setUser(user);
}

export function clearSession() {
  useAuthStore.getState().clearAuth();
}
